/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_History_Page_SizeInputs */

const fr_validation_history_page_size = /** @type {(inputs: Validation_History_Page_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une taille de page comprise entre 1 et 100.`)
};

const en_validation_history_page_size = /** @type {(inputs: Validation_History_Page_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a page size between 1 and 100.`)
};

/**
* | output |
* | --- |
* | "Choose a page size between 1 and 100." |
*
* @param {Validation_History_Page_SizeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_history_page_size = /** @type {((inputs?: Validation_History_Page_SizeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_History_Page_SizeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_history_page_size(inputs)
	return fr_validation_history_page_size(inputs)
});